module.exports = __webpack_public_path__ + "img/kk-back.6d73bff6.png";